import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-3]",
  templateUrl: "./wall-type-3.component.html",
  styleUrls: ["./wall-type-3.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType3Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Management
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M1 ${baseHeight + 15} L3 85 L96 144 L96 ${baseHeight + 80} Z`,
        right: `M96 144 L231 60 L231 ${baseHeight - 5} L96 ${baseHeight + 80} Z`
    };

    return wallData[wallSide];
  }
}
